'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtAddressClaim', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtAddressClaim: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.showHeader = true;

				attrs.$observe('pmtAddressClaim', function (newVal) {
					scope.address = scope.$eval(newVal);
				});
				attrs.$observe('disableHeader', function (newVal) {
					scope.showHeader = !scope.$eval(newVal);
				});
			},
			templateUrl: 'shared/dataPrinters/pmtAddressClaimView.html'
		};
	}
]);
